import React, { Fragment, useState, useEffect, useContext } from 'react';
import TableBuilder, { ApiRequestBuilder, FormOptionsBuilder, RegisteredInputsBuilder, ModalButtonBuilder, ToastBuilder, ButtonBuilder } from '../../GlobalComponents/Builders';
import { Row, Card, CardBody, Form, Container } from 'reactstrap'
import { useForm } from 'react-hook-form';
import { Col } from 'react-bootstrap';
import { AccountContext } from '../../GlobalComponents/Authentication/Accounts';
import { Link } from 'react-router-dom';
import { buildOptionsFromArray, renameKeysCamelToSnake } from '../../GlobalComponents/Helpers';

const OEPDashboard = () => {

    const { userSession } = useContext(AccountContext);

    const { register, handleSubmit, formState: { errors } } = useForm();

    const [renderPage, setRenderPage] = useState(false);  
    const [orders, setOrders] = useState([]);   
    const [closedOrders, setClosedOrders] = useState([]);  
    const [orderTypes, setOrderTypes] = useState([]);  

    const handleNewOrderCreate = (orderData) => {
        
        ApiRequestBuilder('oepOrdersPost', {}, renameKeysCamelToSnake(orderData))
            .then(function(results) {
                if (results.data)
                {
                    ToastBuilder('success', 'Order Creation Successful')
                    window.location.href = process.env.PUBLIC_URL + '/oep/orders/' + String(results.data.order_id)
                }
                else ToastBuilder('error', 'Unable to Create Order')
            }
        )
    }

    const getOrders = () => {

        ApiRequestBuilder('oepOrdersGet', null, null, null, { columns: 'order_id,order_number,order_type_name,company_name,is_closed' })
            .then(function(results) {

                setOrders(results.data.length > 0 ? results.data.filter(order => order.is_closed === 0) : [])
                setClosedOrders(results.data.length > 0 ? results.data.filter(order => order.is_closed === 1) : [])

                ApiRequestBuilder('oepOrdersTypesGet')
                    .then(function(results) {
                        setOrderTypes(results.data.length > 0 ? results.data : [])
                        setRenderPage(true)
                    }
                )
            }
        )
    }

    var orderForm = [
        {
            label: 'Order #', 
            name: 'orderNumber',
            labelSize: 3,
            inputSize: 6,
            size: 12,
            required: true,
            type: 'number'
        },
        {
            label: 'Order Type', 
            name: 'orderType',
            type: 'select',
            labelSize: 3,
            inputSize: 6,
            size: 12,
            options: <FormOptionsBuilder options={buildOptionsFromArray(orderTypes, { label: 'name', value: 'type_id' })}/>
        },
        {
            label: 'Company Name',
            name: 'companyName',
            labelSize: 3,
            inputSize: 6,
            size: 12,
        },
        {
            label: 'Client Status',
            type: 'select',
            labelSize: 3,
            inputSize: 6,
            size: 12,
            required: true,
            options: <FormOptionsBuilder options={buildOptionsFromArray(['New', 'Existing'], { labelIsValue: true })}/>,
            name: 'clientStatus'
        },
        {
            label: 'Carrier',
            type: 'select',
            labelSize: 3,
            inputSize: 6,
            size: 12,
            required: false,
            options: <FormOptionsBuilder options={buildOptionsFromArray(['AT&T', 'T-Mobile', 'Verizon'], { labelIsValue: true })}/>,
            name: 'carrier'
        },
        {
            label: 'Passcode',
            name: 'passcode',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Account #',
            name: 'accountNumber',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Sim Provided By?',
            type: 'select',
            labelSize: 3,
            inputSize: 6,
            size: 12,
            required: false,
            options: <FormOptionsBuilder options={buildOptionsFromArray(['Carrier', 'Wireless Support'], { labelIsValue: true })}/>,
            name: 'simProvidedBy'
        },
        {
            label: 'Tax Id',
            name: 'taxId',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Spoc',
            name: 'spoc',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Associated Name',
            name: 'associatedName',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Spoc email',
            name: 'spocEmail',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Associated Email',
            name: 'associatedEmail',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Order By',
            name: 'orderBy',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Shipping Address',
            name: 'shippingAddress',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Shipping Option',
            name: 'shippingOption',
            type: 'select',
            labelSize: 3,
            inputSize: 6,
            size: 12,
            required: false,
            options: <FormOptionsBuilder options={buildOptionsFromArray(['2 Day', 'Overnight (Extra Charge)'], { labelIsValue: true })}/>,
        },
        {
            label: 'Order Emails',
            name: 'orderEmails',
            type: 'textarea',
            helpText: 'Separate emails by (,) comma.',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Order Instructions',
            name: 'orderInstructions',
            type: 'textarea',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Promotion Description',
            name: 'promotionDescription',
            type: 'textarea',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Is Account Clean-Up Needed?',
            name: 'cleanupNeeded',
            type: 'checkbox',
            labelSize: 3,
            inputSize: 6,
            size: 12
        },
        {
            label: 'Account Cleanup Details',
            name: 'accountCleanupDetails',
            type: 'textarea',
            labelSize: 3,
            inputSize: 6,
            size: 12,
            helpText: 'If applicable'
        }
    ]

    useEffect(() => {   

        document.title = 'Order Entry Portal'
        getOrders()

    }, []);

    if (renderPage)
    { 
        return (
            <Fragment>
                <Row>
                    <Col xl="6">
                        <Card>
                            <CardBody>
                                <h4>Order Entry Portal</h4>
                                <br/>
                                <ModalButtonBuilder title='Create Order' className='btn-secondary'
                                    body = {
                                        <Form id='create-order-form' onSubmit={handleSubmit((data) => handleNewOrderCreate(data))}>
                                            <RegisteredInputsBuilder
                                                registrator={register}
                                                registratorErrors={errors}
                                                inputs={orderForm}/>
                                        </Form>
                                    }
                                />
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xl="6">
                        <Card>
                            <CardBody>
                                <h4>Actions</h4>
                                <br/>
                                <ModalButtonBuilder title='Import Sales Orders' className='btn-primary'
                                        body={
                                            <Form id='import-sales-orders-form' onSubmit={
                                                handleSubmit((formData) => 
                                                    ApiRequestBuilder('oepImportOrdersPost', {}, formData)
                                                        .then(function(results) {
                                                            ToastBuilder('success', 'Fetching Sales Orders')
                                                            setTimeout(() => getOrders(), 15000)
                                                        }
                                                    ))
                                                }>
                                                <p>Please enter a valid sales order number to be imported into the system. To import all the latest sales orders, please leave the field blank.</p><br/>
                                                <p>Note that it may take up to 3 minutes to import all the sales orders and their products depending on how many orders need to be processed.</p><br/>
                                                <RegisteredInputsBuilder
                                                    registrator={register}
                                                    registratorErrors={errors}
                                                    inputs={[
                                                        {
                                                            label: 'Order Number',
                                                            size: 12,
                                                            placeholder: 'Leave Blank for All New Orders',
                                                            name: 'importOrderNumber'
                                                        }
                                                    ]}/>
                                            </Form>
                                        }
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            <Row>
                <Container>
                    <Card>
                        <CardBody>
                            <TableBuilder
                                data = {orders}
                                processing = {false}
                                title = 'Open Orders'
                                subHeader={true}
                                columnsToSearch = {['order_number', 'company_name']}
                                columns = {[
                                    {
                                        name: 'Order #',
                                        selector: (row) => row.order_number,
                                        sortable: true,
                                        center: true,
                                        maxWidth: '8%'
                                    },
                                    { 
                                        name: 'Type',
                                        selector: (row) => row.order_type_name,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Company',
                                        selector: (row) => row.company_name,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Manage',
                                        selector: (row) => <Link to={`${process.env.PUBLIC_URL}/oep/orders/${row.order_id}`}>View / Edit</Link>, 
                                        sortable: false,
                                        center: true,
                                        maxWidth: '12%'
                                    }
                                ]}
                            />
                        </CardBody>
                    </Card> 
                </Container>
                { userSession.email == 'atong@wirelesssupport.com' || userSession.email == 'ckolar@wirelesssupport.com' || userSession.email.includes('@nexnow.net') ? 
                <Container>
                    <Card>
                        <CardBody>
                            <TableBuilder
                                data = {closedOrders}
                                processing = {false}
                                title = 'Closed Orders'
                                subHeader={true}
                                columnsToSearch = {['order_number', 'company_name']}
                                columns = {[
                                    {
                                        name: 'Order #',
                                        selector: (row) => row.order_number,
                                        sortable: true,
                                        center: true,
                                        maxWidth: '8%'
                                    },
                                    {
                                        name: 'Type',
                                        selector: (row) => row.order_type_name,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Company',
                                        selector: (row) => row.company_name,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Manage',
                                        selector: (row) => <Link to={`${process.env.PUBLIC_URL}/oep/orders/${row.order_id}`}>View / Edit</Link>, 
                                        sortable: false,
                                        center: true,
                                        maxWidth: '12%'
                                    }
                                ]}
                            />
                        </CardBody>
                    </Card>
                </Container> : null }
            </Row>
            </Fragment>
        )
    }
    else 
    {
        return <p>Loading Orders...</p>
    }
};

export default OEPDashboard;
